import { motion } from 'framer-motion';
import './BottomNav.css';

const ICONS = {
  menu: (active) => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 6h18M3 12h18M3 18h18"/>
    </svg>
  ),
  favorites: (active) => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth={active ? 0 : 1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  ),
  orders: (active) => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
      <rect x="9" y="3" width="6" height="4" rx="1"/>
      <path d="M9 12h6M9 16h4"/>
    </svg>
  ),
  cart: (active) => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
  ),
  profile: (active) => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  ),
};

export default function BottomNav({ activeTab, onTabChange, cartCount, unreadOrders }) {
  const tabs = [
    { id: 'menu',      label: 'Menu' },
    { id: 'favorites', label: 'Saved' },
    { id: 'orders',    label: 'Orders',  badge: unreadOrders },
    { id: 'cart',      label: 'Cart',    badge: cartCount },
    { id: 'profile',   label: 'Profile' },
  ];

  return (
    <div className="bottom-nav visible">
      <div className="bottom-nav-inner">
        {tabs.map(tab => {
          const active = activeTab === tab.id;
          return (
            <button key={tab.id} className={`nav-tab ${active ? 'active' : ''}`} onClick={() => onTabChange(tab.id)}>
              {active && (
                <motion.div
                  layoutId="activeTabPill"
                  className="nav-active-pill"
                  transition={{ type: "spring", stiffness: 350, damping: 25 }}
                />
              )}
              {ICONS[tab.id](active)}
              <span className="nav-label">{tab.label}</span>
              {tab.badge > 0 && <span className="nav-badge">{tab.badge}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
